/**
 * GTD Domain Symbols - String constants for dependency injection
 * 
 * Separated from container module to avoid circular dependencies.
 * Services import symbols, container module imports services - this breaks the cycle.
 */
export const GTD_DOMAIN_SYMBOLS = {
  // Inbox Management Bounded Context
  InboxItemApplicationService: 'InboxItemApplicationService',
  InboxItemAggregateRepository: 'InboxItemAggregateRepository',
  GTDQueryService: 'GTDQueryService',
  PersonLookupService: 'PersonLookupService',
  GTDProcessingWorkflowService: 'GTDProcessingWorkflowService',
  InboxImportExportService: 'InboxImportExportService',
  
  // Project Management Bounded Context
  ProjectApplicationService: 'GTDProjectApplicationService',
  ProjectReadService: 'ProjectReadService',
  ProjectRepository: 'ProjectRepository',
  NextActionAggregateRepository: 'NextActionAggregateRepository',
  NextActionWriteService: 'NextActionWriteService',
  NextActionReadService: 'NextActionReadService',
  
  // Task Management Bounded Context
  ITaskRepository: 'ITaskRepository',
  TaskMongoRepository: 'TaskMongoRepository',
  GetReferenceItemService: 'GetReferenceItemService',
  InboxFileRepository: 'InboxFileRepository',
  NextActionsFileRepository: 'NextActionsFileRepository',
  
  // Cross-cutting Services
  GtdDomainSeeder: 'GtdDomainSeeder'
};